import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Refund } from '../models/refund';
import { Observable } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { Ordered } from '../models/ordered';

@Injectable({
  providedIn: 'root'
})
export class RefundService {

  private itemDoc: AngularFirestoreDocument<Refund>;
  private item: Observable<Refund>;

  public refundDataSource: MatTableDataSource<any>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions) { }

  select() {
    return this.db.collection<Refund>('sbccv_refunds', ref => ref.orderBy('date', 'asc')).snapshotChanges();
  }

  loadRefunds(product_id) {
    return this.db.collection<Refund>('sbccv_refunds', ref => ref
      .where("product_id", "==", product_id)
      .orderBy('date', 'asc')).snapshotChanges()
      .subscribe((result) => {
        let array: Refund[] = []
        result.forEach((item) => {

          let entity: Refund = new Refund()
          entity.id = item.payload.doc.id
          entity.percent = item.payload.doc.data().percent
          entity.product_id = item.payload.doc.data().product_id
          entity.date = item.payload.doc.data().date

          array.push(entity)

        })

        this.refundDataSource = new MatTableDataSource(array);

      })
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Refund>('sbccv_refunds/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  selectByProductId(product_id) {
    return this.db.collection<Refund>('sbccv_refunds', ref => ref
      .where("product_id", "==", product_id)).snapshotChanges();
  }

  insert(entity: Refund) {
    delete entity.id;
    return this.db.collection('sbccv_refunds').add(Object.assign({}, entity));
  }

  update(entity: Refund) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_refunds').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_refunds').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    /*
    let msgError: string
        switch (errorsCode) {
          case "":
            msgError = ""
            break;
        }
        return msgError
    */
    return errorsCode
  }

  createRefundObj(item) {

    let order = new Ordered();
    order.id = item.payload.doc.id;
    order.date = item.payload.doc.data().date;
    order.product_id = item.payload.doc.data().product_id;
    order.product_name = item.payload.doc.data().product_name;
    order.member_id = item.payload.doc.data().member_id;
    order.member_name = item.payload.doc.data().member_name;
    order.member_cpf = item.payload.doc.data().member_cpf;
    order.member_cellPhone = item.payload.doc.data().member_cellPhone;
    order.member_email = item.payload.doc.data().member_email;
    order.member_debit = item.payload.doc.data().member_debit;
    order.category_id = item.payload.doc.data().category_id;
    order.category_name = item.payload.doc.data().category_name;

    order.payAsOverdue = item.payload.doc.data().payAsOverdue;
    order.until_date = item.payload.doc.data().until_date;
    order.lot_id = item.payload.doc.data().id;

    order.payment_date = item.payload.doc.data().payment_date;
    order.payment_type = item.payload.doc.data().payment_type;

    order.value = item.payload.doc.data().value;
    order.total = item.payload.doc.data().total;
    order.total_minus_tax = item.payload.doc.data().total_minus_tax;

    order.member_debit = item.payload.doc.data().member_debit;

    if (item.payload.doc.data().discount)
      order.discount = item.payload.doc.data().discount;
    else
      order.discount = 0.00;

    order.card_brand = item.payload.doc.data().card_brand;
    order.card_number = item.payload.doc.data().card_number;
    order.card_installments = item.payload.doc.data().card_installments;
    order.card_softdescriptor = item.payload.doc.data().card_softdescriptor;
    order.card_holder = item.payload.doc.data().card_holder;
    order.card_expirationDate = item.payload.doc.data().card_expirationDate;

    order.billet_name = item.payload.doc.data().billet_name;
    order.billet_identity = item.payload.doc.data().billet_identity;
    order.billet_street = item.payload.doc.data().billet_street;
    order.billet_number = item.payload.doc.data().billet_number;
    order.billet_complement = item.payload.doc.data().billet_complement;
    order.billet_zipCode = item.payload.doc.data().billet_zipCode;
    order.billet_district = item.payload.doc.data().billet_district;
    order.billet_city = item.payload.doc.data().billet_city;
    order.billet_state = item.payload.doc.data().billet_state;
    order.billet_country = item.payload.doc.data().billet_country;

    order.type = item.payload.doc.data().type;
    order.paymentId = item.payload.doc.data().paymentId;
    order.Tid = item.payload.doc.data().Tid;
    order.returnCode = item.payload.doc.data().returnCode;
    order.proofOfSale = item.payload.doc.data().proofOfSale;
    order.authorizationCode = item.payload.doc.data().authorizationCode;

    order.tax = item.payload.doc.data().tax;

    order.cash_operator = item.payload.doc.data().cash_operator;
    order.origin = item.payload.doc.data().origin;

    order.refund = item.payload.doc.data().refund;


    return order;

  }

}


